import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddpayadjdetailComponent } from '../addpayadjdetail/addpayadjdetail.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AdddepartmentpopupComponent } from '../../generalpopup/adddepartmentpopup/adddepartmentpopup.component';
import { AdddesignationpopupComponent } from '../../generalpopup/adddesignationpopup/adddesignationpopup.component';
import { AddgradepopupComponent } from '../../generalpopup/addgradepopup/addgradepopup.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';

@Component({
  selector: 'app-addpayadj',
  templateUrl: './addpayadj.component.html',
  styleUrls: ['./addpayadj.component.css']
})
export class AddpayadjComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "PayAdjustment";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean=false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  payadjdetailColl: any = [];

  payadjColl: any = [];
  payadjid: number = 0

  payadjBO: any = {};

  salarytypeColl: any = [];
  emppayColl: any = [];
  emppaytotal: any = 0;

  totallowanceamt: any = 0
  totdeductionamt: any = 0
  totsalaryamt: any = 0


  totcurrentamt: any = 0
  totrevisionamt: any = 0

  departmentColl: any = [];
  designationColl: any = [];
  gradeColl: any = [];

  isdepartmentaddmode: boolean = false;
  isdesignationaddmode: boolean = false;
  isgradeaddmode: boolean = false;


  empColl: any = [];
  empBO: any = {}

  checkfeildmsg: any = "";
  
  payadjform = new FormGroup({
    payadjid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    effectivedt: new FormControl(null),
    transdt: new FormControl(null, Validators.required),
    amount: new FormControl(null),
    salarytype: new FormControl(''),
    descr: new FormControl(''),
    isincrement: new FormControl(false),
    fromdesignationid: new FormControl(null),
    fromdepartmentid: new FormControl(null),
    fromgradeid: new FormControl(null),
    designationid: new FormControl(null),
    departmentid: new FormControl(null),
    gradeid: new FormControl(null),
    ispromotion: new FormControl(false),
    issalaryadj: new FormControl(false),
    promoeffectivedt: new FormControl(null),
    inactive: new FormControl(false),
  });

  lastdepartmentname: string = ""
  lastdepartmentid: any = null;
  lastdesignationname: string = ""
  lastdesignationid: any = null;
  lastgradename: string = ""
  lastgradeid: any = null;

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.payadjid = params.id
      }
    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.payadjform.reset();
      this.fnInitializeFormGroup();

      if (this.payadjid > 0) {
        this.fngetPayadj();
      }
      this.fngetEmployee();
      this.fnGetSalaryType();
      this.fngetDepartment();
      this.fngetDesignation();
      this.fngetGrade();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.payadjid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    this.isdepartmentaddmode= this.loginService.fnCheckUserRoleAction("Department", 'CREATE')
    this.isdesignationaddmode= this.loginService.fnCheckUserRoleAction("Designation", 'CREATE')
    this.isgradeaddmode= this.loginService.fnCheckUserRoleAction("Grade", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.payadjform.setValue({
      payadjid: 0,
      empid: null,
      effectivedt:null,
      transdt: new Date(),
      amount: null,
      salarytype: 'Increment',
      descr: '',
      isincrement: true,
      fromdesignationid: null,
      fromdepartmentid: null,
      fromgradeid: null,
      designationid: null,
      departmentid: null,
      gradeid: null,
      ispromotion: false,
      issalaryadj: false,
      promoeffectivedt: null,
      inactive: false
    })
  }

  fnGetSalaryType() {
    this.salarytypeColl = [];
    this.salarytypeColl.push({ 'displayname': 'Increment', 'value': 'Increment' })
    this.salarytypeColl.push({ 'displayname': 'Decrement', 'value': 'Decrement' })
  }

  fngetEmployee() {
    this.isemploading=true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading=false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading=false;
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fngetPayadj() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'payadjid': this.payadjid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getPayadj(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.payadjColl = res.json().result[0];

            var editdata = this.payadjColl[0];
            this.payadjBO = editdata;
            this.fnEditMode(editdata);


            //this.payadjdetailColl = res.json().result[1];

            //this.fnCalculateTotal();
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeSalaryType() {
    if (this.payadjform.get('salarytype').value === 'Increment') {
      this.payadjform.patchValue({ 'isincrement': true })
    } else {
      this.payadjform.patchValue({ 'isincrement': false })
    }

  }


  fnGetCurrentDepartmentDesign() {

    if (this.payadjid > 0) {
      return;
    }

    var empid = this.payadjform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {

        if (abo.empid === empid) {
          this.lastdepartmentid = abo.departmentid;
          this.lastdepartmentname = abo.departmentname;
          this.lastdesignationid = abo.designationid;
          this.lastdesignationname = abo.designationname;
          this.lastgradeid = abo.gradeid;
          this.lastgradename = abo.gradename;
        }
      }

    }
    else {
      this.lastdepartmentid = null;
      this.lastdepartmentname = null;
      this.lastdesignationid = "";
      this.lastdesignationname = "";
      this.lastgradeid = null;
      this.lastgradename = "";
    }

    this.payadjform.patchValue({
      fromdepartmentid: this.lastdepartmentid,
      fromdesignationid: this.lastdesignationid,
    })


    this.fnChangeEmpLookup();
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.payadjform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }


  fngetDepartment() {

    var data = {
      'departmentid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.departmentColl = res.json().result;            
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetDesignation() {
    var data = {
      'designationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.designationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetGrade() {
    var data = {
      'gradeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGrade(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.gradeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetEmpByEmpid() {
    this.emppayColl = [];
    
    if (!this.payadjform.get('empid').value) {
      return;
    }
    if (!this.payadjform.get('issalaryadj').value) {
      return;
    }

    var data = {
      'empid': this.payadjform.get('empid').value,
      'payadjid': this.payadjid
    }
    this.appService.getPayadjdetailsByEmp(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;

            this.payadjdetailColl = result;

            this.fnCalculateTotal();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  
  fnSetFormValidation() {
    
    var ispromotion = false,issalaryadj=false;
    ispromotion = this.payadjform.get('ispromotion').value;
    issalaryadj = this.payadjform.get('issalaryadj').value;
    
    //Promotion
    if (ispromotion) {
      this.payadjform.controls['promoeffectivedt'].setValidators(Validators.required);   

      if (this.payadjid > 0) {
        if (!this.payadjBO.promoeffectivedt) {
          this.payadjform.patchValue({'promoeffectivedt':new Date()})
        }
      } else {
        this.payadjform.patchValue({'promoeffectivedt':new Date()})
      }
    }
    else {
      this.payadjform.controls['promoeffectivedt'].clearValidators();
      this.payadjform.controls['promoeffectivedt'].setErrors(null);
      this.payadjform.controls['promoeffectivedt'].setValidators(null);
    }

    //Salary Adj
    if (issalaryadj) {
      this.payadjform.controls['effectivedt'].setValidators(Validators.required);
      
      if (this.payadjid > 0) {
        if (!this.payadjBO.effectivedt) {
          this.payadjform.patchValue({'effectivedt':new Date()})
        }
      } else {
        this.payadjform.patchValue({'effectivedt':new Date()})
      }

    }
    else {
      this.payadjform.controls['effectivedt'].clearValidators();
      this.payadjform.controls['effectivedt'].setErrors(null);
      this.payadjform.controls['effectivedt'].setValidators(null);
    }
  }


  fnResetValidation() {
      

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('issalaryadj'))) {
      this.payadjform.controls['issalaryadj'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('promoeffectivedt'))) {
      this.payadjform.controls['promoeffectivedt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('effectivedt'))) {
      this.payadjform.controls['effectivedt'].setErrors(null);
    }

      
    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('departmentid'))) {
      this.payadjform.controls['departmentid'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('designationid'))) {
      this.payadjform.controls['designationid'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('gradeid'))) {
      this.payadjform.controls['gradeid'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('amount'))) {
      this.payadjform.controls['amount'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.payadjform.get('inactive'))) {
      this.payadjform.controls['inactive'].setErrors(null);
    }

  }

  fnValidation() {

    var _ischeck = false;

    if (!this.payadjform.get('issalaryadj').value && !this.payadjform.get('ispromotion').value) {
      this.payadjform.controls['issalaryadj'].setErrors({ 'notfound': true  });
      _ischeck= true;
    }

    //SALARY RIVISION
    if (this.payadjform.get('issalaryadj').value) {
   
      if (this.loginService.fnCompareDateValidation(this.payadjform.get('effectivedt').value, this.payadjform.get('transdt').value)) {
        this.payadjform.controls['effectivedt'].setErrors({ 'notfound': true });
        _ischeck=  true
      }
      if(this.totallowanceamt === 0) {
        this.payadjform.controls['amount'].setErrors({ 'required': true });
        _ischeck=  true;
      }
    }



    //PROMOTION
    if (this.payadjform.get('ispromotion').value) {

      if (this.loginService.fnCompareDateValidation(this.payadjform.get('promoeffectivedt').value, this.payadjform.get('transdt').value)) {       
        this.payadjform.controls['promoeffectivedt'].setErrors({ 'notfound': true });
        _ischeck = true;
      }
      
      if (this.payadjform.get('departmentid').value===null && this.payadjform.get('designationid').value===null  && this.payadjform.get('gradeid').value===null) {
        this.payadjform.controls['departmentid'].setErrors({'required': true});
        _ischeck=  true;
      }

      if (this.payadjform.get('departmentid').value) {
        if (this.payadjform.get('departmentid').value===this.payadjform.get('fromdepartmentid').value) { 
          this.payadjform.controls['departmentid'].setErrors({'notfound': true});
          _ischeck=  true;
        }
      }

      if (this.payadjform.get('designationid').value) {
        if (this.payadjform.get('designationid').value===this.payadjform.get('fromdesignationid').value) { 
          this.payadjform.controls['designationid'].setErrors({'notfound': true});
          _ischeck=  true;
        }
      }

      if (this.payadjform.get('gradeid').value) {
        if (this.payadjform.get('gradeid').value===this.payadjform.get('fromgradeid').value) { 
          this.payadjform.controls['gradeid'].setErrors({'notfound': true});
          _ischeck=  true;
        }
      }

    }

    return _ischeck;

}

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
   

      this.fnResetValidation()

      //Validate   
      if (this.payadjform.valid) {
        
        if (this.fnValidation()) {
          return false
        }
      

        this.saveloading = true;

        if (this.payadjform.get('salarytype').value === 'Increment') {
          this.payadjform.patchValue({ 'isincrement': true })
        } else {
          this.payadjform.patchValue({ 'isincrement': false })
        }

        //Check
        var data = {
          'payadjid': this.payadjid,
          'effectivedt': this.fnFormatDatetime(this.payadjform.get('effectivedt').value),
          'transdt': this.fnFormatDatetime(this.payadjform.get('transdt').value),
          'empid': this.payadjform.get('empid').value,
          'amount': this.payadjform.get('amount').value,
          'inactive': this.payadjform.get('inactive').value,
          'isincrement': this.payadjform.get('isincrement').value,
          'descr': this.payadjform.get('descr').value,
          //'companyid':this.loginService.fnGetCompanyId(),
          'fromdesignationid': this.payadjform.get('fromdesignationid').value,
          'fromdepartmentid': this.payadjform.get('fromdepartmentid').value,
          'fromgradeid': this.payadjform.get('fromgradeid').value,
          'designationid': this.payadjform.get('designationid').value,
          'departmentid': this.payadjform.get('departmentid').value,
          'gradeid': this.payadjform.get('gradeid').value,
          'ispromotion': this.payadjform.get('ispromotion').value,
          'issalaryadj': this.payadjform.get('issalaryadj').value,
          'promoeffectivedt': this.fnFormatDatetime(this.payadjform.get('promoeffectivedt').value),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'payadjdetailscoll': this.payadjdetailColl
        }
        
        this.appService.fnCheckPayadj(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresponce = res.json().result[0];

              var _checkresult = _checkresponce.checkfield;

              if (_checkresult === 'done') {

                if (this.payadjform.get('payadjid').value > 0) {
                  //Update 
                  this.fnSetPayadj(data);
                }
                else {
                  //Insert 
                  this.fnInsertPayadj(data);
                }

              }
              else {
                if (_checkresult === "COMMON") {                  
                  this.saveloading = false;
                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.payadjform.controls['inactive'].setErrors({ 'notfound': true });
                }
              }   
            }
          },(err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertPayadj(data) {

    this.appService.fnInsertPayadj(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new Payadj has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result) {
              this.fnEditFormEdit(_result);
            }
           
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPayadj(data) {

    this.appService.fnSetPayadj(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The Payadj has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.payadjid, this.fngetDescriptionRefno(data));

            this.fnEditFormEdit(this.payadjid);
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  fnEditFormEdit(id) {

    this.payadjid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {      
      this.ngOnInit();
    });

  }

  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/Payadj'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Grid

  fnAddPayAdjDetails() {

    const modalRef = this.productFindService.open(AddpayadjdetailComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = 'allowance';
    modalRef.componentInstance.payadjdetailColl = this.payadjdetailColl;
    modalRef.componentInstance.adjustmenttype = this.payadjform.get('salarytype').value
    
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.payadjdetailColl.push(receivedEntry);
      this.fnCalculateTotal();

    });
  }


  fnEditPayAdjDetails(index) {


    const modalRef = this.productFindService.open(AddpayadjdetailComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = 'allowance';

    var data = this.payadjdetailColl[index];

    modalRef.componentInstance.payadjdetid = data.payadjdetid;
    modalRef.componentInstance.allowanceid = data.allowanceid;
    modalRef.componentInstance.amount = data.amount;
    modalRef.componentInstance.adjustmenttype = this.payadjform.get('salarytype').value
    modalRef.componentInstance.payadjdetailColl = this.payadjdetailColl;


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


      this.payadjdetailColl[index].payadjdetid = receivedEntry.payadjdetid;
      this.payadjdetailColl[index].allowanceid = receivedEntry.allowanceid;
      this.payadjdetailColl[index].amount = receivedEntry.amount;
      this.payadjdetailColl[index].deductionid = receivedEntry.deductionid;



      this.fnCalculateTotal();

    });

  }

    //AddExpenseType
    private fnAddDepartment() {

      const modalRef = this.productFindService.open(AdddepartmentpopupComponent, { size: <any>'l' });
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
        this.fngetDepartment();
  
        if (receivedEntry > 0) {
          this.payadjform.patchValue({ payadjid: receivedEntry })
        }
      });
  
    }  //AddExpenseType
    private fnAddDesignation() {
  
      const modalRef = this.productFindService.open(AdddesignationpopupComponent, { size: <any>'l' });
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
        this.fngetDesignation();
  
        if (receivedEntry > 0) {
          this.payadjform.patchValue({ designationid: receivedEntry })
        }
      });
  
    }  //AddExpenseType
    private fnAddGrade() {
  
      const modalRef = this.productFindService.open(AddgradepopupComponent, { size: <any>'l' });
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
        this.fngetGrade();
  
        if (receivedEntry > 0) {
          this.payadjform.patchValue({ gradeid: receivedEntry })
        }
      });
  
    }
  fnDeletePayAdjConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.payadjdetailColl.splice(index, 1);
            this.fnCalculateTotal();
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  private fnEditMode(deptBO) {
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.promoeffectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.promoeffectivedt));
    this.payadjform.setValue({
      payadjid: deptBO.payadjid,
      empid: deptBO.empid,
      effectivedt: deptBO.effectivedt,
      transdt: deptBO.transdt,
      amount: deptBO.amount,
      salarytype: deptBO.salarytype,
      descr: deptBO.descr,
      isincrement: deptBO.isincrement,
      fromdesignationid: deptBO.fromdesignationid,
      fromdepartmentid: deptBO.fromdepartmentid,
      fromgradeid: deptBO.fromgradeid,
      designationid: deptBO.designationid,
      departmentid: deptBO.departmentid,
      gradeid: deptBO.gradeid,
      ispromotion: deptBO.ispromotion,
      issalaryadj: deptBO.issalaryadj,
      promoeffectivedt: deptBO.promoeffectivedt,
      inactive: deptBO.inactive
    });

    this.fngetEmpByEmpid();

    this.formmode = "Edit";


    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    
    this.lastdepartmentid = deptBO.fromdepartmentid;
    this.lastdepartmentname = deptBO.fromdepartmentname;
    this.lastdesignationid = deptBO.fromdesignationid;
    this.lastdesignationname = deptBO.fromdesignationname;
    this.lastgradeid = deptBO.fromgradeid;
    this.lastgradename = deptBO.fromgradename;


    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount();   

  }

  fnCalculateTotal() {

    this.totallowanceamt = 0;
    this.totdeductionamt = 0;
    this.totsalaryamt = 0;

    this.totcurrentamt = 0;
    this.totrevisionamt = 0;

    for (let abo of this.payadjdetailColl) {
      if (abo.allowanceid > 0) {
        this.totallowanceamt = this.totallowanceamt + abo.amount;
      }
      else if (abo.deductionid > 0) {
        this.totdeductionamt = this.totdeductionamt + abo.amount;
      }

      abo.totalamount = abo.amount + abo.emppayamount;
      
      this.totcurrentamt = this.totcurrentamt + abo.emppayamount;
      this.totrevisionamt = this.totrevisionamt + abo.totalamount;
         
    }

    this.totsalaryamt = this.totallowanceamt - this.totdeductionamt;


    this.payadjform.patchValue({
      amount: this.totsalaryamt
    });
  }



  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetPayadj();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.payadjBO.approvedstatus !== '') {
      if (this.payadjBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.payadjBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.payadjid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    
    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetPayadj();
      }
    });

    

  }


  fnAttachmentSave(tid) {


  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }

  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.payadjid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetPayadj();
      }


    });
  }
  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.payadjid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  


  //Attachment
  fnGetAttachmentCount() {
    if (this.payadjid > 0) {
      var data = {
        'trxid': this.payadjid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }


  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
    
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}